import React from 'react';
import { isPresent } from 'utils/helperMethods';
import { useTranslation } from 'react-i18next';

import useScreen from 'hooks/useScreen';
import Avatar from 'sharedComponents/Avatar';
import LoanOfficerPresenter from 'presenters/realEstateAgent/LoanOfficerPresenter';

import { Typography } from '@material-ui/core';

import useStyles from './useStyles';

const LoanOfficerCard = props => {
  const { loanOfficer } = props;
  const classes = useStyles();
  const { isDesktop } = useScreen();
  const { t } = useTranslation();

  const isCompanyLogotypePresent = isPresent(LoanOfficerPresenter.companyLogoUrl(loanOfficer));

  return (
    <div className={classes.container}>
      <div className={classes.mainBox}>
        <Avatar size="m" className={classes.avatar} imageUrl={LoanOfficerPresenter.profileImageUrl(loanOfficer)} />
        <div className={classes.loanOfficerBadge}>
          <Typography noWrap variant="subtitle1" color="secondary">
            {t('models.App.userTypes.loanOfficer')}
          </Typography>
          <Typography noWrap variant="h3" className={classes.name}>
            {LoanOfficerPresenter.loanOfficerName(loanOfficer)}
          </Typography>
        </div>
        {isDesktop && (
          <div className={classes.loanOfficerInfo}>
            <Typography variant="subtitle1" color="secondary">
              {t('components.ReferralRealEstateAgent.FavoriteLoanOfficersList.LoanOfficerCard.nmls')}
            </Typography>
            <Typography noWrap variant="h3" color="inherit" className={classes.label}>
              {LoanOfficerPresenter.nmls(loanOfficer)}
            </Typography>
          </div>
        )}
      </div>
      {isDesktop && (
        <div className={classes.infoBox}>
          {isCompanyLogotypePresent && (
            <img
              alt="company logo"
              src={LoanOfficerPresenter.companyLogoUrl(loanOfficer)}
              className={classes.companyLogo}
            />
          )}
          <div className={classes.locationBadge}>
            <Typography variant="subtitle1" color="secondary">
              {t('components.ReferralRealEstateAgent.FavoriteLoanOfficersList.LoanOfficerCard.branchLocation')}
            </Typography>
            <Typography noWrap variant="h3" color="inherit" className={classes.label}>
              {LoanOfficerPresenter.branchLocation(loanOfficer)}
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
};

LoanOfficerCard.propTypes = {
  loanOfficer: LoanOfficerPresenter.shape().isRequired,
};

export default LoanOfficerCard;



// WEBPACK FOOTER //
// ./src/components/ReferralRealEstateAgent/components/FavoriteLoanOfficersList/components/LoanOfficerCard/LoanOfficerCard.js